import * as React from "react";

import {StringValueListEditor} from "../string-value-list-editor/string-value-list-editor";
import {TagItem} from "../tag-cache/tag-cache";
import {TagListEditorItem} from "./tag-list-editor-item";

interface ITagListEditorProps {
    slugs: string[];
    onChange: (values: string[]) => void;
    mediaId: string;
    availableTags: TagItem[];
}

export class TagListEditor extends React.Component<ITagListEditorProps> {
    public render() {
        return (
            <StringValueListEditor
                values={this.props.slugs}
                onChange={this.props.onChange}
                itemRenderer={(props) => {
                    const filtered = this.props.availableTags.filter((tag) => {
                        return tag.slug === props.value || !this.props.slugs.includes(tag.slug);
                    });
                    return (
                        <TagListEditorItem
                            mediaId={this.props.mediaId}
                            isPrimary={props.order === 0 && !!props.value}
                            value={props.value}
                            placeholder="タグを追加"
                            onChange={(value) => props.onChange(value ? value.slug : null)}
                            onRemove={props.onRemove}
                            availableTags={filtered}
                        />
                    );
                }}
            />
        );
    }
}
